// extracted by mini-css-extract-plugin
export default {"topSlot":"MobileNav_topSlot__8VLP8","topSpacer":"MobileNav_topSpacer__z7VBG","bottomSlot":"MobileNav_bottomSlot__MH3iP","topSpacerWithBanner":"MobileNav_topSpacerWithBanner__EuVqj"};